import queries from '@apis/queries';
import { BannerRow } from '@models/banner';
import { useQuery } from '@tanstack/react-query';
import { useCookies } from 'react-cookie';

function usePopupBanners() {
  const { data } = useQuery(queries.banners.list('POPUP'));
  const cookieNames = data?.banners
    .map((banner) => bannerToCookieName(banner)) || [];
  const [cookies] = useCookies(cookieNames);
  // 쿠키에 존재하지 않는 배너만 필터링
  const banners = data?.banners.filter((banner) => !cookies[bannerToCookieName((banner))]);
  return {
    banners,
  };
}

function bannerToCookieName(banner: BannerRow): string {
  return `banner_${banner.id}`;
}

export default usePopupBanners;
